import React from 'react'
import { Box, Flex, Spinner } from '@chakra-ui/react'

interface LoadingScreenProps {
  title?: string
  description?: string
  fullpage?: boolean
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ title, description, fullpage = false }) => {
  const radioSpinner = '48px'
  return (
    <Flex
      h='100vh'
      w={`100${fullpage ? 'vw' : '%'}`}
      top={0}
      left={0}
      position='fixed'
      flexDir='column'
      alignItems='center'
      justifyContent='center'
      background={fullpage ? 'white' : 'inherit'}
    >
      <Spinner
        data-testid='spinner'
        w={radioSpinner}
        h={radioSpinner}
        emptyColor='primary.500'
        color='primary.60'
        borderWidth='0.25rem'
      />
      <Box textStyle='h4Bold' data-testid='loadingTitle'>{title}</Box>
      <Box textStyle='bodyLg' data-testid='loadingDescription'>{description}</Box>
    </Flex>
  )
}

export default LoadingScreen
